import _ from "lodash";
import { inWords, inWords2 } from "../../utils";
import {
    computeInvoiceTotalsOld,
    applyExternalDiscountOnTaxable,
} from "../../utils/billInvoiceTotals";

export const invTempOld = (data) => {
    let {
        includeQRCode,
        clientAddress,
        clientName,
        clientGSTNo,
        challanDate,
        items,
        bank,
        bankQrUrl,
        billCode,
        entityDetails,
        packagingCosts,
        isEligibleForIgst,
        invDate,
        entityLogoUrl,
        externalDiscountPercentage,
    } = data;

    const extDiscPct = Number(externalDiscountPercentage) || 0;

    const safeEntity = entityDetails || {};
    const entityNameUpper = (safeEntity.name || "").toUpperCase();
    const resolvedLogoUrl = entityLogoUrl || safeEntity.logoUrl || safeEntity.logo || safeEntity.image || "";

    // Bill code format: PREFIX-NUMBER-DD-MM-YY; show only NUMBER (e.g. 1 or 11)
    const billCodeParts = (billCode || "").split("-");
    const displayBillCode = billCodeParts.length >= 4
        ? billCodeParts[billCodeParts.length - 4]
        : (billCode || "");

    let TotalPackagingCost = 0;
    const pkgCosts = packagingCosts || [];
    for (let cost of pkgCosts) {
        TotalPackagingCost += Number(cost) || 0;
    }

    let bankName = "SYNDICATE BANK",
        bankAccNo = "5015 1400 000 418",
        bankIFSC = "SYNB 000 5015",
        bankBranch = "Zaveri Bazar Kalbadevi Mumbai - 2";
    if (bank) {
        bankName = bank.bankName || bankName;
        bankAccNo = bank.acNo || bankAccNo;
        bankIFSC = bank.ifscCode || bankIFSC;
        bankBranch = bank.branch || bankBranch;
    }

    const invTotals = computeInvoiceTotalsOld(
        items,
        packagingCosts,
        isEligibleForIgst
    );
    const {
        totalQuantity,
        totalAmount,
        taxableValue,
        totalCgst,
        totalSgst,
        totalIgst,
        taxPercentBase,
        cgstPer,
        sgstPer,
        igstPer,
        displayHsn,
    } = invTotals;

    let rows = "";

    (items || []).forEach((o) => {
        let {
            amount,
            rate,
            nameL,
            nameR,
            quantity,
            fittingAmount,
            tint,
            discountAmount,
            discountPercent,
            hsnCode,
            taxPercent,
            orderRef
        } = o;

        const amt = Number(amount) || 0;
        const qty = Number(quantity) || 0;
        const effTaxPercent = Number.isFinite(Number(taxPercent)) && Number(taxPercent) > 0
            ? Number(taxPercent)
            : (o?.isPrescriptionOrder ? 5 : taxPercentBase);

        const nameParts = [nameL, nameR].filter(Boolean);
        let name = nameParts.join(" ") + (orderRef ? ` (${orderRef})` : "");
        name = name.replace(/-/g, "/");

        let cgstAmt = 0, sgstAmt = 0, igstAmt = 0;
        let cgstP = 0, sgstP = 0, igstP = 0;

        if (isEligibleForIgst) {
            igstP = effTaxPercent;
            igstAmt = (effTaxPercent / 100) * amt;
        } else {
            cgstP = effTaxPercent / 2;
            sgstP = effTaxPercent / 2;
            cgstAmt = (effTaxPercent / 200) * amt;
            sgstAmt = (effTaxPercent / 200) * amt;
        }

        const item = {
            name,
            hsn: o?.isPrescriptionOrder ? "90015000" : (hsnCode || ""),
            rate: rate || "",
            quantity: qty,
            amount: amt,
            discount: discountAmount ? Number(discountAmount) : discountPercent ? `${discountPercent}%` : "",
            ec: Number(fittingAmount || 0) + Number(tint || 0),
            cgstPercent: cgstP,
            cgst: cgstAmt,
            sgstPercent: sgstP,
            sgst: sgstAmt,
            igstPercent: igstP,
            igst: igstAmt,
            isEligibleForIgst
        };

        rows += renderTableRow(item) + "\n";
    });

    let packagingRow = "";
    if (TotalPackagingCost > 0) {
        const pkgTaxAmt = isEligibleForIgst
            ? (igstPer / 100) * TotalPackagingCost
            : ((cgstPer + sgstPer) / 100) * TotalPackagingCost;

        packagingRow = renderTableRow({
            name: "Packaging Charges",
            hsn: "",
            rate: "",
            quantity: "",
            amount: TotalPackagingCost,
            discount: "",
            ec: "",
            cgstPercent: isEligibleForIgst ? 0 : cgstPer,
            cgst: isEligibleForIgst ? 0 : pkgTaxAmt / 2,
            sgstPercent: isEligibleForIgst ? 0 : sgstPer,
            sgst: isEligibleForIgst ? 0 : pkgTaxAmt / 2,
            igstPercent: isEligibleForIgst ? igstPer : 0,
            igst: isEligibleForIgst ? pkgTaxAmt : 0,
            isEligibleForIgst
        });
    }

    const discResult = applyExternalDiscountOnTaxable(
        invTotals,
        extDiscPct,
        isEligibleForIgst
    );
    const roundOff = discResult.roundOff;
    const grandTotal = discResult.finalGrandTotal;
    const showFootTaxable = discResult.discountedTaxable;
    const footIgst = discResult.totalIgstAfter;
    const footCgst = discResult.totalCgstAfter;
    const footSgst = discResult.totalSgstAfter;
    const footTotalTax = discResult.totalTaxAfter;
    const totalAmountInWords = inWords2(grandTotal);

    return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>Invoice</title>
    <style>
        body {
            font-family: Arial, Helvetica, sans-serif;
            font-size: 9.5pt;
            color: #000;
            margin: 0;
        }
        .border { border: 1px solid #000; }
        .center { text-align: center; }
        .row { display: flex; }
        table {
            width: 100%;
            border-collapse: collapse;
            font-size: 9.5pt;
        }
        th, td {
            border: 1px solid #000;
            padding: 5px 6px;
            vertical-align: top;
            line-height: 1.3;
        }
        .description { width: 32%; text-align: left; padding-left: 8px; word-wrap: break-word; overflow-wrap: break-word; }
        .hsn        { width: 9%; }
        .qty        { width: 6%; text-align: center; }
        .rate       { width: 9%; text-align: right; }
        .amount     { width: 12%; text-align: right; }
        .tax-col    { width: 6%; text-align: right; }
        .nowrap     { white-space: nowrap; }
        .bold       { font-weight: bold; }

        /* PDF page header (shown on every page) */
        .page-header {
            position: fixed;
            left: 50%;
            transform: translateX(-50%);
            top: 4mm;
            width: 820px; /* match invoice container width */
            font-size: 9pt;
            color: #000;
            display: none; /* avoid overlay in screen/canvas rendering */
            z-index: 9999;
            background: #fff;
        }
        .page-header-inner {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 8px;
            padding-bottom: 1.2mm;
            border-bottom: 1px solid #000;
        }
        .page-header .party-name {
            font-weight: bold;
            max-width: 70%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .page-header .page-no::before {
            content: "Page " counter(page);
        }
        @media print {
            .page-header { display: block; }
            /* Ensure the first printed page is "Page 1" (some renderers start at 0). */
            body { counter-reset: page 1; }
            @page {
                size: A4;
                /* Leave room at the top for Party + Page header */
                margin: 16mm 10mm 12mm 10mm;
            }
            .no-print { display: none !important; }
            tr { page-break-inside: avoid; }
            thead { display: table-header-group; }
            tfoot { display: table-footer-group; }
        }
    </style>
</head>
<body>
<div class="page-header">
  <div class="page-header-inner">
    <div class="party-name">${clientName || ""}</div>
    <div class="page-no"></div>
  </div>
</div>

<div class="border" style="width: 820px; margin: 16px auto; padding: 0 0 16px 0;">
    <!-- Header -->
    <div class="row border" style="padding: 12px; align-items: center; gap: 16px;">
        ${resolvedLogoUrl ? `<img src="${resolvedLogoUrl}" style="width:70px;height:70px;object-fit:contain;" alt="Logo"/>` : ""}
        <div style="flex:1; text-align:center;">
            <h2 style="margin:0; text-transform:uppercase;">${entityNameUpper}</h2>
            <div style="font-size:9pt; margin-top:4px;">${safeEntity.address || ""}</div>
            <div>GSTIN: ${safeEntity.gst || ""} ΓÇâ| ┬áContact: ${safeEntity.phone || ""}</div>
        </div>
    </div>

    <!-- Client & Invoice Info -->
    <div class="row" style="margin-top:8px; gap:8px;">
        <div class="border" style="flex:1; padding:8px;">
            <div class="center border" style="margin:-8px -8px 8px -8px; padding:4px;"><strong>CLIENT DETAILS</strong></div>
            <div><strong>${clientName || ""}</strong></div>
            <div class="row"><span>Address:</span><span style="flex:1; padding-left:8px;">${clientAddress || ""}</span></div>
            <div class="row"><span>GSTIN:</span><span style="padding-left:8px;">${clientGSTNo || ""}</span></div>
        </div>
        <div class="border" style="flex:1; padding:8px;">
            <div class="center border" style="margin:-8px -8px 8px -8px; padding:4px;"><strong>INVOICE DETAILS</strong></div>
            <div class="row"><span>Bill Code:</span><span style="padding-left:8px;">${displayBillCode}</span></div>
            <div class="row"><span>Bill Date:</span><span style="padding-left:8px;">${invDate || ""}</span></div>
        </div>
    </div>

    <!-- Items Table -->
    <table style="margin-top:12px;">
        <thead>
            <tr class="bold">
                <th class="description">Description</th>
                <th class="hsn">HSN Code</th>
                <th class="qty">Qty</th>
                <th class="rate">Rate</th>
                <th class="amount">Amount</th>
                ${isEligibleForIgst ? `
                <th class="tax-col">IGST %</th>
                <th class="tax-col">IGST Amt</th>
                ` : `
                <th class="tax-col">CGST %</th>
                <th class="tax-col">CGST Amt</th>
                <th class="tax-col">SGST %</th>
                <th class="tax-col">SGST Amt</th>
                `}
            </tr>
        </thead>
        <tbody>
            ${rows}
            ${packagingRow}
        </tbody>
    </table>

    <!-- Summary -->
    <table style="margin-top:2px;">
        <tr class="bold">
            <th class="description">
                <div class="row" style="justify-content:space-between;">
                    <span>Amount in Words:</span>
                    <span>E. & O.E.</span>
                </div>
                <div style="margin-top:4px;">${totalAmountInWords} Rupees Only</div>
            </th>
            <th class="qty">${totalQuantity}</th>
            <th class="rate">${_.round(totalAmount, 2).toFixed(2)}</th>
            <th class="amount">${_.round(showFootTaxable, 2).toFixed(2)}</th>
            <!-- Always show three tax amount columns: IGST, CGST, SGST -->
            <th class="tax-col">${_.round(footIgst, 2).toFixed(2)}</th>
            <th class="tax-col">${_.round(footCgst, 2).toFixed(2)}</th>
            <th class="tax-col">${_.round(footSgst, 2).toFixed(2)}</th>
        </tr>
    </table>

    <!-- Tax Summary + Grand Total -->
    <div class="border" style="margin-top:8px;">
        ${extDiscPct > 0 ? `
        <div class="row" style="padding:6px; border-bottom:1px solid #000;">
            <div style="width:52%; padding-left:6px;">Total challan (taxable)</div>
            <div style="width:32%;"></div>
            <div style="width:16%; text-align:right;">${_.round(taxableValue, 2).toFixed(2)}</div>
        </div>
        <div class="row" style="padding:6px; border-bottom:1px solid #000;">
            <div style="width:52%; padding-left:6px;">Discount @ ${extDiscPct}%</div>
            <div style="width:32%;"></div>
            <div style="width:16%; text-align:right;">-${_.round(discResult.discountAmount, 2).toFixed(2)}</div>
        </div>
        <div class="row" style="padding:6px; border-bottom:1px solid #000;">
            <div style="width:52%; padding-left:6px;">Sub total</div>
            <div style="width:32%;"></div>
            <div style="width:16%; text-align:right;">${_.round(discResult.discountedTaxable, 2).toFixed(2)}</div>
        </div>
        ` : ''}
        <div class="row bold" style="padding:6px; background:#f8f8f8;">
            <div style="width:16%;">HSN CODE</div>
            <div style="width:16%;">Taxable Value</div>
            <div style="width:16%;">IGST @ ${igstPer}%</div>
            <div style="width:16%;">CGST @ ${cgstPer}%</div>
            <div style="width:16%;">SGST @ ${sgstPer}%</div>
            <div style="width:16%; text-align:right;">Total Tax</div>
        </div>
        <div class="row" style="padding:6px;">
            <div style="width:16%;">${displayHsn}</div>
            <div style="width:16%;">${_.round(showFootTaxable, 2).toFixed(2)}</div>
            <div style="width:16%;">${_.round(footIgst, 2).toFixed(2)}</div>
            <div style="width:16%;">${_.round(footCgst, 2).toFixed(2)}</div>
            <div style="width:16%;">${_.round(footSgst, 2).toFixed(2)}</div>
            <div style="width:16%; text-align:right;">${_.round(footTotalTax, 2).toFixed(2)}</div>
        </div>

        ${Math.abs(roundOff) > 0.01 ? `
        <div class="row" style="padding:6px; border-top:1px solid #000;">
            <div style="width:84%;"></div>
            <div style="width:16%; display:flex; justify-content:space-between;">
                <span>Round Off:</span>
                <span>${roundOff >= 0 ? '+' : ''}${_.round(roundOff, 2).toFixed(2)}</span>
            </div>
        </div>
        ` : ''}

        <div class="row bold" style="padding:8px; background:#f0f0f0; font-size:11pt;">
            <div style="width:84%;"></div>
            <div style="width:16%; display:flex; justify-content:space-between;">
                <strong>Total:</strong>
                <strong>${_.round(grandTotal, 2).toFixed(2)}</strong>
            </div>
        </div>
    </div>

    <!-- Bank & Signature -->
    <div class="row" style="margin-top:16px; gap:8px; align-items:stretch;">
        <div class="border" style="flex:1; padding:8px;">
            <div class="center border" style="margin:-8px -8px 8px -8px; padding:4px;"><strong>BANK DETAILS</strong></div>
            <div class="row"><span>A/c No.:</span><span style="padding-left:8px;">${bankAccNo || "-"}</span></div>
            <div class="row"><span>Bank:</span><span style="padding-left:8px;">${bankName || "-"}</span></div>
            <div class="row"><span>Branch:</span><span style="padding-left:8px;">${bankBranch || "-"}</span></div>
            <div class="row"><span>IFSC:</span><span style="padding-left:8px;">${bankIFSC || "-"}</span></div>
        </div>

        ${includeQRCode && (bankQrUrl || billCode) ? `
        <div class="border" style="width:180px; display:flex; flex-direction:column; align-items:center; justify-content:center; padding:12px;">
            <strong>Scan to Pay</strong>
            <img src="${bankQrUrl || `https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent(billCode || "")}`}" 
                 style="width:130px; height:130px; margin:8px 0;" alt="Payment QR"/>
        </div>
        ` : ""}

        <div class="border" style="flex:1; display:flex; flex-direction:column; justify-content:space-between; padding:8px;">
            <div class="center border" style="margin:-8px -8px 8px -8px; padding:4px;">
                <strong>FOR ${entityNameUpper}</strong>
            </div>
            <div class="center" style="margin-top:auto;">
                <div style="height:40px;"></div>
                <div>Authorised Signatory</div>
                <div style="font-size:8pt; margin-top:4px;">Computer Generated Invoice</div>
            </div>
        </div>
    </div>
</div>

</body>
</html>`;
};

const renderTableRow = (item) => {
    const {
        name,
        hsn,
        quantity,
        rate,
        amount,
        cgstPercent,
        cgst,
        sgstPercent,
        sgst,
        igstPercent,
        igst,
        isEligibleForIgst
    } = item;

    return `<tr style="page-break-inside: avoid;">
        <td class="description">${name || ""}</td>
        <td class="hsn">${hsn || ""}</td>
        <td class="qty">${quantity || ""}</td>
        <td class="rate">${rate ? Number(rate).toFixed(2) : ""}</td>
        <td class="amount">${Number(amount).toFixed(2)}</td>
        ${isEligibleForIgst ? `
        <td class="tax-col">${Number(igstPercent).toFixed(1)}</td>
        <td class="tax-col">${Number(igst).toFixed(2)}</td>
        ` : `
        <td class="tax-col">${Number(cgstPercent).toFixed(1)}</td>
        <td class="tax-col">${Number(cgst).toFixed(2)}</td>
        <td class="tax-col">${Number(sgstPercent).toFixed(1)}</td>
        <td class="tax-col">${Number(sgst).toFixed(2)}</td>
        `}
    </tr>`;
};
